import Input, { InputProps } from "./Input.tsx";
import styles from "./VInputGroup.module.css";
import classNames from "classnames";

interface VInputGroupProps extends InputProps {
  label: string;
  inputWidth?: string;
  labelWidth?: string;
  id?: string;
  isTouched?: boolean;
  isValid?: boolean;
  readonly?: boolean;
  onBlur?: () => void;
}

const VInputGroup = (props: VInputGroupProps) => {
  const labelStyle = props.labelWidth ? { width: props.labelWidth } : {};
  return (
    <div className={styles.spacer}>
      <label
        htmlFor={props.label + "_input"}
        className={classNames(styles.inputLabel, {
          [styles.invalid]: props.isTouched && !props.isValid,
          [styles.valid]: props.isTouched && props.isValid,
        })}
        id={props.label + "_input"}
        style={labelStyle}
      >
        {props.label}
      </label>
      <Input {...props} width={props.inputWidth} />
    </div>
  );
};

export default VInputGroup;
